module.exports = __webpack_public_path__ + "static/media/img-request.a0dd5e3f.png";